import { getEditLocation } from "../../../core/util/functions";

export const countriesLocation = "/listing/codebook/countries";
export const getCountryEditLocation = (id?: string) => getEditLocation(countriesLocation, undefined, id);
export const editRouter = getCountryEditLocation(":cntId?");
